import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CreateDepositPage from "./pages/CreateDepositPage";
import CreateDepositSuccessPage from "./pages/CreateDepositSuccessPage";
import CheckoutPage from "./pages/CheckoutPage";
import ReleaseDepositPage from "./pages/ReleaseDepositPage";
import CollectDepositPage from "./pages/CollectDepositPage";
import OurPricesPage from "./pages/OurPricesPage";
import ContactPage from "./pages/ContactPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import NotFoundPage from "./pages/NotFoundPage";

import ScrollToTop from "./utils/ScrollToTop";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/create" element={<CreateDepositPage />} />
        <Route path="/createDepositSuccess" element={<CreateDepositSuccessPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/release" element={<ReleaseDepositPage />} />
        <Route path="/collect" element={<CollectDepositPage />} />
        <Route path="/pricing" element={<OurPricesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/checkoutSuccess" element={<CheckoutSuccessPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
